<tiime-dialog [isLoading]="isLoading()" (cancel)="closeCreateDemoCompanyDialog()">
  <span mat-dialog-title>Ajouter un dossier (démo)</span>
  <mat-dialog-content class="dialog-content" mat-dialog-content>
    @if (!submitLoading()) {
      <app-business-unit-select
        tiimeFormInputContainer
        [required]="true"
        [selectData]="data.businessUnits"
        [control]="businessUnitCtrl"
        [allowEmptyOption]="false"
        [errorMessage]="businessUnitCtrlErrorMessage"
      ></app-business-unit-select>
      <button tiime-button color="accent" raised large action (click)="createDemoCompany()">Ajouter</button>
    } @else {
      <div class="submit-loader">
        <span>Création du dossier en cours...</span>
        <mat-progress-spinner diameter="50" color="primary" mode="indeterminate"></mat-progress-spinner>
      </div>
    }
  </mat-dialog-content>
</tiime-dialog>
